export const localisationConfigs = {
  default: {
    timeFormats: {
      AdBy: 'ddd DD MMM YYYY',
      AdBy_d: 'D-MMM-YYYY',
      AdBy_l: 'ddd DD/MM/YYYY',
      AddBy: 'dddd, DD MMMM YYYY',
      ABy: 'DD MMMM YYYY',
      ABy_d: 'D MMM YYYY',
      dby: 'DD-MMM-YYYY',
      ybd: 'YYYY-MM-DD',
      ybd_hm: 'YYYY-MM-DD HH:mm',
      ybd_hms: 'YYYY-MM-DDTHH:mm:ss',
      dby_hm: 'DD MMM YYYY HH:mm',
      AdBy_lt: 'ddd D MMM YYYY LT',
      hm: 'HH:mm',
    },
  },
  us: {
    timeFormats: {
      AdBy: 'ddd, MMM DD YYYY',
      AdBy_d: 'MMM-D-YYYY',
      AdBy_l: 'ddd MM/DD/YYYY',
      AddBy: 'dddd, MMMM DD YYYY',
      ABy: 'MMMM DD YYYY',
      ABy_d: 'MMM D YYYY',
      dby: 'MMM-DD-YYYY',
      ybd: 'YYYY-DD-MM',
      ybd_hm: 'YYYY-DD-MM HH:mm',
      ybd_hms: 'YYYY-DD-MMTHH:mm:ss',
      dby_hm: 'MMM DD YYYY HH:mm',
      AdBy_lt: 'ddd MMM D YYYY LT',
      hm: 'HH:mm',
    },
  },
};
